import { router } from 'js-dom-router';
import lazyModules from './lazyModules'

// attach lazy modules event listeners
lazyModules()
console.log('called')

router.ready();
